import { render } from "./AppAdatkezelesi.vue?vue&type=template&id=f32aeec8&scoped=true"
import script from "./AppAdatkezelesi.vue?vue&type=script&lang=js"
export * from "./AppAdatkezelesi.vue?vue&type=script&lang=js"

import "./AppAdatkezelesi.vue?vue&type=style&index=0&id=f32aeec8&scoped=true&lang=css"

import exportComponent from "F:\\repos\\ideahonlapom\\gombavezetes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32aeec8"]])

export default __exports__